module.exports = __webpack_public_path__ + "static/media/logo.9c0c9ab5.png";